import { Badge } from "../../components/Badge/Badge";

import { environmentLook } from "./environment";

export function EnvironmentBadge({ environment }: { environment: string }) {
  const look = environmentLook(environment);
  return (
    <Badge variant={look.variant} dot>
      {look.label}
    </Badge>
  );
}
